/**
 * One step in a product demo breakdown — uses the shared nd1-step pattern.
 */
export default function FlowStep({ icon: Icon, title, description, tag, tagIcon: TagIcon }) {
  return (
    <div className="nd1-step">
      <span className="nd1-step__icon">
        <Icon className="nd1-icon" aria-hidden="true" />
      </span>
      <div className="nd1-step__body">
        {tag ? (
          <span className="nd1-eyebrow-chip">
            {TagIcon ? <TagIcon className="nd1-icon" aria-hidden="true" /> : null}
            {tag}
          </span>
        ) : null}
        <div className="nd1-step__head">
          <h4>{title}</h4>
        </div>
        <p className="nd1-step__desc">{description}</p>
      </div>
    </div>
  );
}
